// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3lTC2","content":"Consent_content__3FTka","footer":"Consent_footer__2FA3U"};